import { BusinessUnits, Facilities } from './customer';

export class BuFacility {
    lookupCode?: string;
    lookupCodeDescription?: string;
    facility?: Facilities;
    bu?: BusinessUnits;
}
export class LangList{
    code?: string;
    lang?: string;
}

export class Errors {
    errorMessage?: string;
    exceptionResponse: ErrorCode[];
}

export class ErrorCode {
    code?: string;
    description?: string;
}

export class Paging {
    last?: boolean;
    first?: boolean;
    totalPages?: number;
    totalElements?: number;
    size?: number;
    number?: number;
    numberOfElements?: number;
    next?: string;
}

export class AddressVerificationRequest {
    addresses?: Address[];
}

export class Address {
    addressLines?: string[];
    city?: string;
    stateProvinceCode?: string;
    postalCode?: string;
    countryCode?: string;
    locality?: string;
    skipEFS?: boolean;
}